import { Pause, Play, ListChecks, Archive } from 'lucide-react';

export const COLUNAS_KANBAN = {
  pendente: { 
    label: 'Inativa', 
    color: 'bg-stone-400', 
    textColor: 'text-stone-600', 
    bgLight: 'bg-stone-50',
    borderColor: 'border-stone-200',
    icon: Pause 
  },
  producao: { 
    label: 'Ativa', 
    color: 'bg-emerald-500', 
    textColor: 'text-emerald-700', 
    bgLight: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    icon: Play 
  },
  conclusoes: {
    label: 'Conclusoes',
    color: 'bg-blue-500',
    textColor: 'text-blue-700',
    bgLight: 'bg-blue-50',
    borderColor: 'border-blue-200',
    icon: ListChecks
  },
  arquivado: { 
    label: 'Arquivado', 
    color: 'bg-stone-400', 
    textColor: 'text-stone-600', 
    bgLight: 'bg-stone-50',
    borderColor: 'border-stone-200',
    icon: Archive 
  }
};
